import {
  PARTICULARS_MOBILE_OPERATOR_ERROR,
  PARTICULARS_MOBILE_OPERATOR_REQUEST,
  PARTICULARS_MOBILE_OPERATOR_SUCCESS,
  CHECK_NUMBER_PORT_REQUEST,
  CHECK_NUMBER_PORT_SUCCESS,
  CHECK_NUMBER_PORT_ERROR,
  RESET_NUMBER_PORT
} from './actionTypes';

import {
  MobileOperatorRequest,
  MobileOperatorSuccess,
  MobileOperatorFailure,
  CheckNumberPortRequest,
  CheckNumberPortSuccess,
  CheckNumberPortFailure
} from './models/types';

export const getMobileOperator = {
  request: (): MobileOperatorRequest => ({ type: PARTICULARS_MOBILE_OPERATOR_REQUEST }),
  success: (data): MobileOperatorSuccess => ({ type: PARTICULARS_MOBILE_OPERATOR_SUCCESS, data }),
  failure: (error): MobileOperatorFailure => ({ type: PARTICULARS_MOBILE_OPERATOR_ERROR, error })
};

export const checkNumberPort = {
  request: (reqData, callback): CheckNumberPortRequest => ({
    type: CHECK_NUMBER_PORT_REQUEST,
    reqData,
    callback
  }),
  success: (data): CheckNumberPortSuccess => ({ type: CHECK_NUMBER_PORT_SUCCESS, data }),
  failure: (error): CheckNumberPortFailure => ({ type: CHECK_NUMBER_PORT_ERROR, error })
};

export const resetNumberPortStore = () => ({ type: RESET_NUMBER_PORT });
